import { CircularProgress, Fade } from '@material-ui/core';
import styledMixins from 'app/styles/styledMixins';
import { ReactComponent as CameraEmptyIcon } from 'assets/icons/camera-empty.svg';
import { ReactComponent as CameraErrorIcon } from 'assets/icons/camera-error.svg';
import React from 'react';
import styled from 'styled-components/macro';

const FadedDiv = styled.div``;
const Overlay = styled.div<{ $scale: number }>`
  position: absolute;
  ${styledMixins.fullsize}
  background: ${p => p.theme.palette.misc.darkGrey};
  ${styledMixins.flexCenter}

  > div {
    position: absolute;
    ${styledMixins.flexCenter}
    transform: scale(${p => p.$scale});
    > * {
      position: absolute;
    }

    .MuiCircularProgress-root {
      color: white;
    }

    > svg {
      width: 180px;
      height: 180px;
      fill: white;
    }
  }

  > ${FadedDiv} {
    .MuiCircularProgress-root {
      color: #fff3;
    }
    > svg {
      fill: #fff3;
    }
  }
`;

type Props = {
  show: boolean;
  state?: 'static' | 'loading' | 'error';
  scale?: number;
};

export default function CameraLoading({
  show,
  state,
  scale = 1,
}: Props): JSX.Element {
  return (
    <Fade in={show}>
      <Overlay $scale={scale}>
        <Fade in={state === 'static'}>
          <FadedDiv>
            <CircularProgress
              size={80}
              variant="determinate"
              value={100}
            />
          </FadedDiv>
        </Fade>
        <Fade in={state === 'static'} timeout={{ exit: 2000 }}>
          <FadedDiv>
            <CameraEmptyIcon />
          </FadedDiv>
        </Fade>

        <Fade
          in={state === 'loading'}
          timeout={{ enter: 2000, exit: 300 }}
        >
          <div>
            <CircularProgress size={80} variant="indeterminate" />
            <CameraEmptyIcon />
          </div>
        </Fade>

        <Fade in={state === 'error'}>
          <div>
            <CameraErrorIcon />
          </div>
        </Fade>
      </Overlay>
    </Fade>
  );
}
